<template>
    <div v-if="generalReportData!=null">
       <!-- titles -->
        <div class="vertFlex" >
            <p class="generaltitle" v-if="generalReportData.title!=null">{{generalReportData.title}}</p>
            <p class="generalsubtitle" v-if="generalReportData.subTitle!=null">{{generalReportData.subTitle }} </p>
            <p class="generalsubtitle" v-if="generalReportData.subTitle2!=null">{{generalReportData.subTitle2 }} </p>
        </div>

        <div class="vertFlex " >
            <!-- superheaders -->
            <div class="horizFlex borderedrow">
                <div v-for="o in generalReportData.superHeaders" :key="o" :value="o" :class="superheaderdivclass(o)">
                    <p class="valuelabelfixed bold" >{{ o.value }}</p>
                </div>
            </div>

            <!-- headers -->
            <div class="horizFlex borderedrow">
                <div v-for="o in generalReportData.headers" :key="o" :value="o" >
                    <div :class="headerdivclass(o)">
                        <linkbutton  @click="setsort(o)" :toplabel="o.value"/>
                    </div>
                </div>
            </div>
            
            <!-- items -->
            <div :class="itemdivclass">
                <div :class="itemclass(s)" v-for="s in sortedItems" :key="s" :value="s">
                    <div :class="valuedivclass(o)" v-for="o in s.values" :key="o" :value="o" >
                        <p :class="valueclass(o)">{{o.value}}</p>
                    </div>
                </div>
            </div>
            
            <!-- footers -->
            <div class="horizFlex borderedrow">
                <div v-for="o in generalReportData.footers" :key="o" :value="o" :class="footerdivclass(o)">
                    <p class="valuelabelfixed  " >{{o.value}}</p>
                </div>
            </div>

        </div>
    </div>
</template>
    
<script>
    
import format from '../../format.js'
    import linkbutton from '../controls/linkbutton.vue';
    export default {
        name:'generalreport',
        components:{
            linkbutton

        },
        props:{
            generalReportData:{
                type:Object,
            },
            tagClassListForValues:{
                type:Array,
                default:null
            },
            colwidth:{
                type:String,
                default:'120px'
            },
            colwidth_wide:{
                type:String,
                default:'240px'
            },
            scrollHeight:{
                type:Number,
                default:0
            }
           
    
        },
        
        mixins:[format],
        data(){
            return{
                sortBy:-1,
                sortaccending:true,

                //this is a sample. Any set of tag class mappings can be sent in to override the default
                defaultTagClassListForValues:[
                    {
                        tag:'Pass',
                        class:'passlabel'
                    },
                    {
                        tag:'Fail',
                        class:'faillabel'
                    }
                ]
            }
        },
        computed:{
            sortedItems(){
                if(this.sortBy==-1){return this.generalReportData.items}

                var sort1 = this.sortaccending ? -1:1
                var sort2 = this.sortaccending ? 1:-1
                var selSortBy = this.sortBy

                //determine if this col is numbers
                if(this.isNumbers(selSortBy)){
                    function compare(a,b){
                        if (Number(a.values[selSortBy].value) < Number(b.values[selSortBy].value))
                            return sort1
                        if(Number(a.values[selSortBy].value) > Number(b.values[selSortBy].value))
                            return sort2
                        return 0
                    }
                    return this.generalReportData.items.sort(compare)
                }else{
                    function compare(a,b){
                        if (a.values[selSortBy].value < b.values[selSortBy].value)
                            return sort1
                        if(a.values[selSortBy].value > b.values[selSortBy].value)
                            return sort2
                        return 0
                    }
                    return this.generalReportData.items.sort(compare)
                }

                

            },
            itemdivclass(){
                if(this.scrollHeight>0){
                    return "scrollvertgeneral"
                }else{return ""}
            }
           
        },
        
        mounted(){
            this.updateProps()
        },
        methods:{
            isNumbers(index){
                var isnumeric = true
                var ex = this.generalReportData.items[0].values[index].value
                //console.log(ex)
                if(isNaN(ex)){isnumeric=false}
                //console.log(index + ' numeric ' + isnumeric)
                return isnumeric
            },
            updateProps(){
                if(this.colWidth!='120px'){
                    document.body.style.setProperty('--colwidth',this.colwidth);
                    document.body.style.setProperty('--colwidth_wide',this.colwidth_wide);
                }
                if(this.scrollHeight>0) {
                    document.body.style.setProperty('--scrollheight',this.scrollHeight + 'px');
                }
                
            },
            setsort(h){
                //if didn't change col, toggle asc/desc
                if(h.index==this.sortBy){this.sortaccending=!this.sortaccending}
                this.sortBy=h.index
                
            },
            itemclass(s){
                //handle inactive class
                var c = "horizFlex borderedrow"
                if(!s.isActive){ c = c + " inactiveItem"}
                return c
            },
            valueclass(o){
                var cls = ""
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLabelFormatClass(o.tag)
                
                return cls
            },
            valuedivclass(o){
                var cls = ""
                cls = cls +  this.getLeftPadAndBorderClass(o.index)
                return cls
            },
            headerdivclass(o){
                var cls ="topbottompad bold"
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLeftPadAndBorderClass(o.index)
                return cls
            },
            superheaderdivclass(o){
                var cls ="topbottompad bold"
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLeftPadAndBorderClass(o.index)
                return cls
            },
            footerdivclass(o){
                var cls ="topbottompad"
                cls=cls + this.getLabelWidthClass(o.tag) + this.getLeftPadAndBorderClass(o.index)
                return cls
            },
            isFirstOfGroup(index){
                //if there aren't any superheaders, then every header is  first, else, any header with a corresponding superheader is a first
                if(this.generalReportData.superHeaders.length==0){return true}
                if(this.generalReportData.superHeaders[index].value!=""){return true}
                else return false
            },
            getLabelWidthClass(tag){
                if(tag=='wide'){return " valuelabelfixedwide"}else{return " valuelabelfixed"}
            },
            getLeftPadAndBorderClass(index){
                if(this.isFirstOfGroup(index)){return " leftpadandborder"}else{return ""}
            },
            //use the tagclass mapping array to add specific class to the value label
            getLabelFormatClass(tag){
                if(tag===null || tag==''){return ""}
                var cls=""

                //if passed in, use those, else use default
                if(this.tagClassListForValues!=null){this.defaultTagClassListForValues=this.tagClassListForValues}
               
                //look for a match
                this.defaultTagClassListForValues.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let tc=arr[index]
                    if(tc.tag==tag){
                        cls=tc.class
                    }
                }
   
                return ' ' + cls
            }
            
        }
    }
</script>
    
<style>
:root{
    --padding:10px;
    --paddingsmall:5px;
    --inactivecolor:rgb(228, 223, 223);
    --linecolor:rgb(197, 190, 190);
    --colwidth:120px;
    --colwidth_wide:240px;
    --scrollheight:250px;
}
p{
    margin:var(--padding) 0px var(--padding) 0px;
}
  .generaltitle{
    margin:var(--paddingsmall);
    font-size:larger;
    font-weight:bold;
  }
  .generalsubtitle{
    margin:var(--paddingsmall);
  }
  .borderedrow{
    border-bottom:1px solid var(--linecolor);
  }
  .topbottompad{
    padding:var(--padding) 0px var(--padding) 0px;
  }
  .valuelabelfixed{
    width:var(--colwidth);
    min-width:var(--colwidth);
    text-align: left;
  }
  .valuelabelfixedwide{
    width:var(--colwidth_wide);
    min-width:var(--colwidth_wide);
    text-align: left;
  }
  .inactiveItem{
    background-color:var(--inactivecolor);
  }
  .leftpadandborder{
    padding-left:var(--padding);
    border-left:1px solid var(--linecolor);
  }
  .passlabel{
    color:green;
  }
  .faillabel{
    color:red;
  }
  .scrollvertgeneral{
    height:var(--scrollheight);
  /* max-height:100%; */
  overflow-y: auto;
  overflow-x:hidden;
  margin:0px;
  }
</style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    